import { AxiosResponse } from 'axios';

import { GetUsersPayload } from '@/api/users/request';
import { GetUsersResponse } from '@/api/users/response';
import { ClientService } from '@/types/api';

export class UsersApi {
	private prefix = 'v2/users';

	constructor(private readonly clientService: ClientService) {
		this.clientService = clientService;
	}

	public async getUsers(payload: GetUsersPayload): Promise<AxiosResponse<GetUsersResponse>> {
		return this.clientService.get(`${this.prefix}`, {
			params: payload,
		});
	}

	public async uploadFile(userId: number, formData: FormData): Promise<AxiosResponse<string>> {
		return this.clientService.post(`${this.prefix}/profile/${userId}/resumes`, formData);
	}

	public async deleteFile(userId: number, fileId: string): Promise<AxiosResponse<void>> {
		return this.clientService.delete(`${this.prefix}/profile/${userId}/resumes/${fileId}`);
	}
}
